(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/login/login.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/login/login.js');
"use strict";


const {
  START,
  PASSWORD_RECOVERY
} = svs.ticket_partner.constants.routes;
const Email = svs.ui.reactFormInputs.EmailInput;
const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  Form
} = svs.ui.reactForm;
const Button = svs.ui.ReactButton;
const {
  Link
} = svs.app.ReactRouter;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  EMAIL_LABEL,
  EMAIL_MAX,
  EMAIL_REQUIRED_ERROR,
  EMAIL_NAME
} = svs.ticket_partner.login.constants.FORMS.EMAIL;
const {
  PASSWORD_LABEL,
  PASSWORD_NAME,
  PASSWORD_REQUIRED_ERROR
} = svs.ticket_partner.login.constants.FORMS.PASSWORD;
const {
  HEADER,
  PASSWORD_LINK,
  LOGIN_BUTTON_LABEL
} = svs.ticket_partner.login.constants.FORMS;
const {
  useState,
  useEffect
} = React;
const {
  PageWrapper
} = svs.ticket_partner.sharedComponents.pageWrapper;
const Login = _ref => {
  let {
    history
  } = _ref;
  const {
    isLoggedIn,
    login
  } = svs.ticket_partner.useUserContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {
    redirectToReturnUrl,
    returnUrl
  } = svs.ticket_partner.sharedComponents.hooks.useReturnUrl(START);
  const PASSWORD_RECOVERY_URL = returnUrl ? "".concat(PASSWORD_RECOVERY, "?returnUrl=").concat(returnUrl) : PASSWORD_RECOVERY;
  useEffect(() => {
    if (isLoggedIn) {
      redirectToReturnUrl();
    }
  }, [isLoggedIn, history, redirectToReturnUrl]);
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    await login(email, password);
    svs.ui.loader.hide();
  };
  return React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 4
    },
    md: {
      col: 4
    },
    sm: {
      col: 12
    },
    xl: {
      col: 4
    },
    xs: 12
  }, React.createElement(Form, {
    isVertical: true,
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), React.createElement(Email, {
    errorMessageRequired: EMAIL_REQUIRED_ERROR,
    id: EMAIL_NAME,
    isRequired: true,
    label: EMAIL_LABEL,
    max: EMAIL_MAX,
    name: EMAIL_NAME,
    onChange: e => setEmail(e.target.value),
    value: email
  }), React.createElement(TextInput, {
    errorMessageRequired: PASSWORD_REQUIRED_ERROR,
    id: PASSWORD_NAME,
    isRequired: true,
    label: PASSWORD_LABEL,
    name: PASSWORD_NAME,
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  }), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Button, {
    inverted: true,
    type: "submit"
  }, LOGIN_BUTTON_LABEL)), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-align-items-center margin-3"
  }, React.createElement(Link, {
    to: PASSWORD_RECOVERY_URL
  }, PASSWORD_LINK))))));
};
svs.ticket_partner.login.Login = Login;

 })(window);